import { DATE_FORMATS } from '@constants/date.ts';
import { TIME_FORMAT_OPTIONS } from '@routes/sidebar/settings/ui/user-preferences-tab/constants.ts';

export const TEXT_INPUT_FIELD_TYPE = 'text-input';
export const SELECT_FIELD_TYPE = 'dropdown';
export const DATE_PICKER_FIELD_TYPE = 'date';
export const STATUS_PILL_FIELD_TYPE = 'status-pill';

export const USER_DETAILS_PARAMS = {
    EMPLOYEE_ID: 'employeeId',
    MAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    DATE_OF_BIRTH_UTC: 'dateOfBirthUTC',
    BACKUP_EMAIL: 'backupEmail',
    PHONE: 'phone',
    NATIONALITY: 'nationality',
    COUNTRY_ID: 'countryId',
    GENDER: 'gender',
    AVATAR_URI: 'avatarURI',
    AVATAR_CONTENT_ID: 'avatarContentId',
    CREATED_AT_UTC: 'createdAtUTC',
    LAST_CHANGED_UTC: 'lastChanged',
    LAST_LOGIN_UTC: 'lastLoginUTC',
    LAST_ACTIVITY_UTC: 'lastActivityUTC',
    REQUIREMENTS_START_UTC: 'requirementsStartDate',
    ACTIVE: 'isActive',
};

export const USER_EMPLOYMENT_DETAILS_PARAMS = {
    EMPLOYER: 'clientOrganisationId',
    EXTERNAL_ID: 'externalId',
    TITLE_RANK: 'vesselRankId',
    TITLE_RANK_SINCE_UTC: 'rankSinceUTC',
    LOCATION: 'clientVesselId',
    LOCATIONS_SINCE_UTC: 'locationSinceUTC',
    MANAGER: 'managerId',
    DEPARTMENT: 'vesselDepartmentId',
    VESSEL_TRAINING_MANAGER: 'trainingManagerId',
    ASSESSOR: 'assessorId',
    // employment details shore user (employment data)
    TITLE: 'titleName',
    TITLE_CODE: 'titleCode',
    JOINED_SINCE_UTC: 'joinedSinceUTC',
    TITLE_SINCE_UTC: 'titleSince',
    TEAM_DEPARTMENT: 'shoreTeamName',
    REPORTS_TO: 'reportsToName',
    // employment details crew user (employment data)
    MANNING_OFFICE: 'manningOfficeName',
    CREWING_TEAM_DEPT: 'crewingTeamName',
    JOINED_SINCE_EMPLOYMENT_UTC: 'joinedSince',
    // employment details crew user (assignment data)
    VESSEL_CURRENT: 'vesselName',
    ON_BOARD: 'isOnboard',
    RANK_CURRENT: 'rankName',
    RANK_CURRENT_SINCE: 'rankSince',
    SIGNED_ON_UTC: 'signOn',
    ACTUAL_SIGN_OFF_UTC: 'actualSignOff',
    VESSEL_NEXT: 'nextPlannedVesselName',
    RANK_NEXT: 'nextPlannedRankName',
    PLANNED_SIGN_ON: 'nextPlannedSignOn',
};

export const USER_PREFERENCES_DEFAULTS = {
    landingPage: '',
    dateFormat: DATE_FORMATS.ISO,
    timeFormat: TIME_FORMAT_OPTIONS[0].value,
    notificationsApp: true,
    notificationsEmail: true,
    lastVisitedPathwayId: null,
};
